var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.68 3.41016H5.32C3.21027 3.41016 1.5 5.12043 1.5 7.23016V16.7702C1.5 18.8799 3.21027 20.5902 5.32 20.5902H18.68C20.7897 20.5902 22.5 18.8799 22.5 16.7702V7.23016C22.5 5.12043 20.7897 3.41016 18.68 3.41016Z",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8197 11.9997L8.17969 15.8197V8.17969L15.8197 11.9997Z",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "bill-reader/static/media/youtube.9a9cdd9ef7b1a7abeffa567bd7d9be19.svg";
export { ForwardRef as ReactComponent };